<div class="subtasks-list">
  <ng-container *ngFor="let task of taskList$ | async; trackBy: trackBy">
    <list-tasks-single-task-v2
      *ngIf="!task.deleted"
      (onChangeParentTask)="onChangeParentTask($event)"
      [parentTask]="service?.parentTask"
      [task]="task"
    ></list-tasks-single-task-v2>
  </ng-container>
</div>
